export const similarProducts = {
  SimilarProducts: "<0>Similar</0> products",
  CuratedByFSIMAT: "Curated by Fullscript's Medical Advisory team",
} as const;
